import React from 'react';
import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer';
import moment from "moment";

// Create styles
Font.register({
    family: 'Oswald',
    src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
  });
  
  const today = moment().format("DD/MM/YYYY");

  const styles = StyleSheet.create({
    sectionHeaderLeft: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
      },
      sectionHeaderRight: {
        marginTop: 10,
        marginLeft: -100,
        marginBottom:10,
        paddingTop: 40,
        paddingLeft: 0,
        flexGrow: 1,
      },
    sectionLeft: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
      }, 
    sectionRight: {
        marginTop: 10,
        marginLeft: -250,
        marginBottom:10,
        paddingTop: 10,
        paddingLeft: -250,
        flexGrow: 1,
      }, 
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },
    subtitle: {
      fontSize: 18,
      margin: 12,
      fontFamily: 'Oswald',
      textAlign: 'center',
    },
    text: {
      marginLeft: 12,
      fontSize: 14,
      textAlign: 'left',
      fontFamily: 'Times-Roman'
    },
    textright: {
        margin: 12,
        fontSize: 14,
        textAlign: 'right',
        fontFamily: 'Times-Roman'
      },
    textMarginBottom: {
        marginLeft: 12,
        marginBottom:12,
        fontSize: 14,
        textAlign: 'left',
        fontFamily: 'Times-Roman'
      },
    textMarginBottomBold: {
        marginLeft: 12,
        marginBottom:12,
        fontSize: 14,
        textAlign: 'left',
        fontFamily: 'Times-Roman',
        fontWeight: 'bold',
      },
    image: {
      marginVertical: 15,
      width: 50,
      height: 50,
    },
    header: {
      fontSize: 12,
      marginBottom: 20,
      textAlign: 'center',
      color: 'grey',
    },
    pageNumber: {
      position: 'absolute',
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
    },
  });

// Create Document Component
const PDFRecuFiscal = (props) => (
    <Document>
    <Page style={styles.body}>
        <View style={{flexDirection:'row'}}>
            <View style={styles.sectionHeaderLeft}>
            <Image
            style={styles.image}
            src="/sajm-logo.jpg"
            />
            </View>
            <View style={styles.sectionHeaderRight}>
            <Text style={styles.header} fixed>
                Reçu Fiscal
            </Text>
            </View>
        </View>
      <Text style={styles.text}>
        Nom de l'Association: AAMF
      </Text>
      <Text style={styles.text}>
        SIRET: 883 926 685 000 24
      </Text>
      <Text style={styles.text}>
        Adresse: 8 rue du Docteur Picard
      </Text>
      <Text style={styles.text}>
        Code Postal: 49640
      </Text>
      <Text style={styles.textMarginBottom}>
        Ville: Morannes-sur-Sarthe
      </Text>
      <Text style={styles.textMarginBottom}>
        _________________________________________________________________________ 
      </Text>
      <Text style={styles.subtitle}>
        Donateur
      </Text>
      <Text style={styles.text}>
        {props.data.nom}, {props.data.prenom}
      </Text>
      <Text style={styles.text}>
        {props.contact.adresse1}
      </Text>
      <Text style={styles.text}>
        {props.contact.adresse2}
      </Text>
      <Text style={styles.textMarginBottom}>
        {props.contact.codepostal} - {props.contact.ville}
      </Text>
      <Text style={styles.text}>
        Le bénéficiaire reconnaît avoir reçu au titre des dons et versements ouvrant droit à une réduction d'impôts
        la somme de *** {props.data.montant} {props.data.devise} ***
      </Text>
      <View style={{flexDirection:'row'}}>
      <View style={styles.sectionLeft}>
        <Text style={styles.textMarginBottomBold}>
            Date: 
        </Text>
        <Text style={styles.textMarginBottomBold}>
            Nature du Don:
        </Text>
        <Text style={styles.textMarginBottomBold}>
            Mode de versement: 
        </Text>
        <Text style={styles.textMarginBottomBold}>
            Référence
        </Text>
      </View>
      <View style={styles.sectionRight}>
        <Text style={styles.textMarginBottom}>
            {props.data.date}
        </Text>
        <Text style={styles.textMarginBottom}>
            {props.data.type_don}
        </Text>
        <Text style={styles.textMarginBottom}>
            {props.data.mode} 
        </Text>
        <Text style={styles.textMarginBottom}>
            {props.data.id}
        </Text>
      </View>
      </View>
      <Text style={styles.textMarginBottom}>
        Le bénéficiaire certifie sur l'honneur que les dons et versements qu'il reçoit ouvrent
        droit à la réduction d'impôt prévue aux articles 200, 238 bis et 978 du Code Général des Impôts.
      </Text>
      <Text style={styles.textright}>
        Fait à Morannes-sur-Sarthe, le {today}
      </Text>
      <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
        `${pageNumber} / ${totalPages}`
      )} fixed />
    </Page>
  </Document>
);

export default PDFRecuFiscal;